import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from '@reduxjs/toolkit'
import rootSaga from './sagas';

import sweepsSlice from './sweeps/slice';
import systemSlice from "./system/slice";
import photosSlice from "./photos/slice";
import videosSlice from './videos/slices';
import usersSlice from "./users/slice";
import authenticationSlice from "./authentication/slice";
import itemsObservationsSlice from "./itemsObservations/slice";
import itemsNamesSlice from "./itemsNames/slice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    sweeps: sweepsSlice,
    system: systemSlice,
    photos: photosSlice,
    videos: videosSlice,
    users: usersSlice,
    itemsObservations: itemsObservationsSlice,
    itemsNames: itemsNamesSlice,
    authentication: authenticationSlice
  },
  middleware: getDefaultMiddleware => [...getDefaultMiddleware({ thunk: false, serializableCheck: false }), sagaMiddleware]
})

sagaMiddleware.run(rootSaga);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type IApplicationState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type IApplicationDispatch = typeof store.dispatch